import { createReducer } from '@reduxjs/toolkit';
import {
    SET_DATA, SET_PLAYLIST, RESET_DATA, SET_CURRENT_PODCAST_SLUG, SET_TEXT,
    SET_ISLOADING, SET_NEXT_URL, SET_CURRENT_URL, NO_MORE_PODCAST,
} from '../actions/MixcloudPodcastActions';

const initialState = {
    mixcloudDataPodcast: [],
    // dataPodcastFiltered: [],
    mixcloudDataPlaylist: [],
    nextUrl: false,
    currentPlaylistSlug: false,
    isLoading: false,
    currentUrl: false,
    noMorePodcasts: false,
    noticeText: '',
};

const mixcloudPodcasts = createReducer(initialState, (builder) => {
    builder
        .addCase(SET_DATA, (state, action) => {
            state.mixcloudDataPodcast = state.mixcloudDataPodcast.concat(action.data);
        })
        .addCase(SET_PLAYLIST, (state, action) => {
            state.mixcloudDataPlaylist = action.mixcloudDataPlaylist;
        })
        .addCase(RESET_DATA, (state) => {
            state.mixcloudDataPodcast = [];
        })
        .addCase(SET_CURRENT_PODCAST_SLUG, (state, action) => {
            state.currentPlaylistSlug = action.slug;
        })
        .addCase(SET_ISLOADING, (state, action) => {
            state.isLoading = action.isLoading;
        })
        .addCase(SET_NEXT_URL, (state, action) => {
            state.nextUrl = action.nextUrl;
        })
        .addCase(SET_CURRENT_URL, (state, action) => {
            state.currentUrl = action.url;
        })
        .addCase(NO_MORE_PODCAST, (state, action) => {
            state.noMorePodcasts = action.noMorePodcasts;
        })
        .addCase(SET_TEXT, (state, action) => {
            state.noticeText = action.noticeText;
        });
});

export default mixcloudPodcasts;
